import { Observable } from "rxjs";

import { get, post, put } from "@utils/axios";
import sessionService from "./session.service";
import { milleniumClientCheck } from "@utils/helpers";
// import { localToUTCFormatDate } from "@utils/helpers";

class DashboardService {
  fetchAllNotifications(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/api/insights`);
  }
  fetchHeaderOptions(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/dashboard/user-lob`);
  }

  updateReport({ reportValue, isStarred, isOpened }: any): Observable<any> {
    let body: any = {
      reportValue: reportValue,
    };

    if (isStarred) {
      body['starmark'] = isStarred;
    }

    if (isOpened) {
      body['opened'] = isOpened;
    }
    return post(`${sessionService.getClient()?.appServiceUrl}/dashboard/update`, { ...body });
  }

  fetchPopulationInsightsReportsInfo(): Observable<any> {
    const isMillennium = milleniumClientCheck()
    const showPersistentMembers = isMillennium ? 'false' : 'true'
    const projection = isMillennium ? 'false' : 'true'

    return get(`${sessionService.getClient()?.appServiceUrl}/insights?projection=${projection}&showPersistentMembers=${showPersistentMembers}`);
  }

  /**
   * Function to fetch Power Bi reports access token to render in report
   */

  fetchPowerBiAccessToken(reportId: string, workSpaceId: string, value?: string): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/dashboard/access-token/${reportId}/${workSpaceId}?value=${value}`);
  }

  fetchPopulationInsightsReportsInfoByDateRange(startDate: string, endDate: string, yearMonth: string): Observable<any> {
    const isMillennium = milleniumClientCheck()
    const showPersistentMembers = isMillennium ? 'false' : 'true'
    const projection = isMillennium ? 'false' : (yearMonth === endDate ? 'true' : 'false')
    return get(`${sessionService.getClient()?.appServiceUrl}/insights?startDate=${startDate}&endDate=${endDate}&projection=${projection}&showPersistentMembers=${showPersistentMembers}`);
  }

  fetchPopulationInsightsReportsInfoByFilters(filters: any, startDate: string, endDate: string, yearMonth: string): Observable<any> {
    const isMillennium = milleniumClientCheck()
    const showPersistentMembers = isMillennium ? 'false' : 'true'
    const projection = isMillennium ? 'false' : (yearMonth === endDate ? 'true' : 'false')
    return post(`${sessionService.getClient()?.appServiceUrl}/insights/filter?startDate=${startDate}&endDate=${endDate}&projection=${projection}&showPersistentMembers=${showPersistentMembers}`, filters);
  }

  fetchMemberListFromPopInst(filters: any, yearMonth: string, type: any, code: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/insights/filter/patient-ids?yearMonth=${yearMonth}&type=${type}&code=${code}`, filters);
  }

  /**
   * Service for Calender View  ?memberId=${patientId}
   */

  fetchCalenderDayViewMasterData(appointmentDate: string, officeID: string, filters?: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/calendar/day/master-data?appointmentDate=${appointmentDate}&officeID=${officeID}`, { filters: filters });
  }

  fetchCalenderDayViewAppointments(appointmentDate: string, officeID?: string, filters?: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/calendar/day/appointment?appointmentDate=${appointmentDate}&officeID=${officeID}`, { filters: filters });
  }

  fetchCalenderViewPatientProfileByPatientID(patientID: string): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/calendar/patient-info?patientID=${patientID}`);
  }

  fetchCalenderViewPatientDayAppointmentDetailsByPatientID(patientID: string): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/calendar/day/appointment-details?patientID=${patientID}`);
  }

  fetchCalenderViewPatientDayARSummaryByPatientID(patientID: string): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/calendar/day/ar-summary?patientID=${patientID}`);
  }

  fetchCalenderViewDayFilter(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/calendar/day/filters`);
  }

  fetchCalenderViewDayFilterV2(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/calendar/day/v2/filters`);
  }
  /////////////////////Month View Services

  fetchCalenderMonthViewMasterData(appointmentDate: string, filters?: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/calendar/month/master-data?selectedDate=${appointmentDate}`, { filters: filters });
  }

  fetchCalenderMonthViewAppointment(startDate: string, filters?: any): Observable<any> {
    //?startDate=${startDate}&endDate=${endDate}
    return post(`${sessionService.getClient()?.appServiceUrl}/calendar/month/appointment?selectedDate=${startDate}`, { filters: filters });
  }

  fetchCalenderMonthViewAppointmentDetails(date: string, balanceOfMonth: boolean, filters?: any): Observable<any> {
    //?startDate=${startDate}&endDate=${endDate}
    return post(`${sessionService.getClient()?.appServiceUrl}/calendar/month/appointment-details?date=${date}&isBalanceMonth=${balanceOfMonth}`, { filters: filters });
  }

  fetchCalenderViewMonthFilter(filters?: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/calendar/month/filters`, { filters: filters });
  }

  /********************* Inpatient Management Report **************************** */

  fetchInpatientManagementReportData({ startDate, endDate, page, limit, searchOn, sortBy, sortType }: any): Observable<any> {
    let param = `pageName=InPatient Management Report&pageNo=${page - 1}&pageLimit=${limit}`;
    param = param + (sortBy && sortType ? `&sortBy=${sortBy}&sortType=${sortType}` : "");
    param = param + (startDate && endDate ? `&startDate=${startDate}&endDate=${endDate}` : "");

    let body = {};

    if (searchOn) {
      body = {
        ...body,
        searchOn: searchOn,
      };
    }

    return post(`${sessionService.getClient()?.appServiceUrl}/patient/inpatient-management-report?${param}`, body);
  }

  updateInpatientManagementReportColumnList({ columns }: any): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/column-preference?pageName=InPatient Management Report`, { columns: columns });
  }

  getInpatientManagementReportColumnList(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/column-list?pageName=InPatient Management Report`);
  }

  downloadInpatientReport({ columns, startDate, endDate, sortBy, sortType, searchOn, columnsType }: any): Observable<any> {
    let param = sortBy && sortType ? `sortBy=${sortBy}&sortType=${sortType}` : "";

    param = param + (startDate && endDate ? `&startDate=${startDate}&endDate=${endDate}` : "");
    let parameters = param === "" ? param : `?${param}`;
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/download-inpatient-report?${parameters}`, { columns: columns, searchOn: searchOn, columnsType: columnsType });
  }

  getMeasuresReportInfo(year: any, tabKey: string, pcpId?: any, pcpVendor?: any, healthPlan?: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/measuresReportInfo`, { year: year, tabKey: tabKey, pcpId: pcpId, pcpVendor: pcpVendor, healthPlan: healthPlan });
  }

  fetchMemberListFromMeasures(measureId: any[], year: any, tabKey: string, healthPlan?: any[], pcpVendor?: any[], provider?: any[], countType?: any): Observable<any> {
    const payload: any = { measureId, year, tabKey };

    if (tabKey === "hedis") {
      payload.healthPlan = healthPlan;
      payload.pcpVendor = pcpVendor;
      payload.pcpId = provider;
      payload.countType = countType;
    }

    return post(`${sessionService.getClient()?.appServiceUrl}/report/measuresReportPatientIds`, payload);
  }

  fetchCareGapSummary(patientIds: string[], tabKey: string): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/download-care-gap-summary`, {
      patientIds: patientIds,
      tabKey: tabKey,
    });
  }

  fetchProvidersForHedisMeasure(healthPlan: any, pcpVendor: any, pcpId: any, year: any, measureId: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/measures/provider-details`, {
      pcpId: pcpId,
      pcpVendor: pcpVendor,
      healthPlan: healthPlan,
      year: year,
      measureId: measureId,
    });
  }
}

export default new DashboardService();
